import { ProviderBookingResult, RefundCaseCancelReason } from '@eti/schema-types';
import type {
  ProviderBookingType,
  RefundCasesType,
  TransformedProviderBookingType,
} from './models';

export const hasRefundProviderBookingToShow = (
  cancelReason: RefundCaseCancelReason,
  providerBooking: ProviderBookingType,
) =>
  providerBooking.__typename === 'RefundCaseRelatedProviderBooking' ||
  (providerBooking.__typename === 'RefundCaseProviderBooking' &&
    !providerBooking.hasAcceptedVoucher &&
    (cancelReason !== RefundCaseCancelReason.OrphanedFunds ||
      providerBooking.providerBookingResult === ProviderBookingResult.Success ||
      providerBooking.steps?.[2]?.completed));

export const getProviderBookings = (cases: RefundCasesType): TransformedProviderBookingType[] => {
  return cases.flatMap((c) =>
    c.providerBookings.reduce((acc: TransformedProviderBookingType[], pr) => {
      if (hasRefundProviderBookingToShow(c.cancelReason, pr)) {
        const transformedProviderBooking = <TransformedProviderBookingType>{
          ...pr,
          cancelReason: c.cancelReason,
        };
        acc.push(transformedProviderBooking);
      }
      return acc;
    }, []),
  );
};
